import { Component } from '@angular/core';

@Component({
  selector: 'app-sujet-contact',
  templateUrl: './sujet-contact.component.html',
  styleUrls: ['./sujet-contact.component.scss']
})
export class SujetContactComponent {

}
